import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, IPayment, IPaymentsQueryParams } from 'gen/ApiClient';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IPayment>, IPaymentsQueryParams>>(undefined as any);
